import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
  theme => ({
    allBrandsText: {
      margin: "0px 25px 0 10px",
      paddingTop: "15px"
    },
    allBrandsTextField: {
      margin: "0px 20px 0px 20px",
      paddingBottom: "25px"
    },
    allCheckbox: {
      width: 100
    },
    allFields: {
      marginLeft: "10px",
      marginRight: "10px"
    },
    allSpan: {
      textAlign: "center"
    },
    allSubsidy: {
      width: "80%"
    },
    allSusidyMain: {
      display: "flex",
      justifyContent: "center"
    },
    allText: {
      fontSize: "1rem",
      marginTop: "10px",
      width: "20%"
    },
    appliedToAllStore: {
      "& .MuiCheckbox-root": {
        padding: 0
      },
      paddingBottom: "5.5px",
      textAlign: "right"
    },
    applyAll: {
      color: "#a7abb5",
      fontSize: "12px",
      marginTop: "10px",
      textAlign: "right"
    },
    applyAllSelectedStore: {
      color: "#a7abb5",
      fontSize: "12px",
      marginTop: "10px"
    },
    applyAllStore: {
      color: "#a7abb5",
      fontSize: "12px",
      textAlign: "right"
    },
    applyToAllSelectedBrands: {
      backgroundColor: "#f4f8ff"
    },
    assignBrands: {
      "& .MuiTypography-h6": {
        fontSize: "16px",
        fontWeight: "bold"
      }
    },
    blueDot: {
      alignItems: "center",
      color: "#0030FF",
      display: "flex",
      fontSize: "43px",
      height: "1px",
      width: "1px"
    },
    buttonAction: {
      "& .MuiButton-root": {
        color: "#0030FF"
      },
      "& .MuiButton-text & .MuiButton-label": {
        color: "#0030FF"
      }
    },
    buttonDelete: {
      "& .MuiButton-root": {
        color: "#0030FF"
      }
    },
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 100 + theme.spacing(0.1)
    },
    colName: {
      fontWeight: "bold",
      paddingLeft: 0,
      width: "25%"
    },
    colPrice: {
      fontWeight: "bold",
      textAlign: "left"
    },
    colStoreName: {
      display: "flex",
      paddingLeft: 0,
      width: "auto"
    },
    dashed: {
      borderTop: "2px dashed #c4c4c4"
    },
    dialogContainer: {
      "& .MuiPaper-root": {
        maxHeight: "60vh",
        overflowY: "visible"
      }
    },
    discountContent: {
      "& .MuiDialogContent-root": {
        padding: 0
      },
      overflowY: "visible"
    },
    selectAll: {
      display: "flex"
    },
    selectBrands: {
      fontWeight: "bold",
      marginBottom: "10px"
    },
    selectallcount: {
      color: theme.palette.primary.main
    },
    selectedSellerName: {
      color: "#1844ff",
      fontSize: "18px",
      fontWeight: "bold",
      marginLeft: "40px"
    },
    sellerName: {
      fontSize: "12px",
      marginLeft: "40px"
    },
    storeButton: {
      "&.MuiButton-containedPrimary:hover ": {
        backgroundColor: "#0030FF",
        color: "#fff"
      },
      "&:hover": {
        "&.MuiButton-containedPrimary span": {
          color: "#fff"
        }
      },
      backgroundColor: "#fff",
      border: "1px solid #0030FF",
      borderRadius: "25px",
      color: "#0030FF"
    },
    storeNumberList: {
      backgroundColor: "#fbdb05",
      borderRadius: "100%",
      color: "#0b38f4",
      fontSize: "15px",
      fontWeight: "bold",
      height: "30px",
      justifyContent: "center",
      marginTop: "5px",
      padding: "10px",
      paddingTop: "5px",
      position: "absolute" as "absolute",
      textAlign: "center",
      width: "30px"
    },
    storeText: {
      "&:hover": {
        color: "#fff"
      }
    },
    tenantRow: {
      "& .MuiTableCell-root": {
        borderBottom: 0
      }
    }
  }),
  { name: "brandGroupDialog" }
);

export default useStyles;
